export default __webpack_public_path__ + "static/media/3.497a08a6.png";